import { Stack } from '@mui/material';
import { FC, useState } from 'react';

import UserDetailRow from '@features/employerAccount/components/UserDetailRow/UserDetailRow';
import { white } from '@styles/colors';
import { getCookie } from '@utils/getCookie';
import TemplateCompanyNameModal from './TemplateCompanyNameModal';
import { EnterpriseTemplate } from '../types';
import ConfirmationModal from './ConfirmationModal';

type UpdateData = {
  label: string;
  type: string;
  formDataKey: string;
  defaultValue: string | null | undefined;
  showEditor: boolean;
};
type TemplateGenralSettingsProps = {
  templateData: EnterpriseTemplate;
};

const TemplateGenralSettings: FC<TemplateGenralSettingsProps> = ({
  templateData,
}) => {
  const dontShowWarningPopup = getCookie('dontShowWarningPopup');
  const isAppliedChanges = templateData.apply_changes && !dontShowWarningPopup;
  const [updateData, setUpdateData] = useState<UpdateData>({
    label: '',
    type: '',
    formDataKey: '',
    defaultValue: undefined,
    showEditor: false,
  });
  const [pendingUpdate, setPendingUpdate] = useState<UpdateData | null>(null);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const handleActionClick = (data: UpdateData) => {
    if (isAppliedChanges) {
      setPendingUpdate(data);
      setIsConfirmOpen(true);
    } else {
      setUpdateData(data);
    }
  };

  const handleConfirm = () => {
    if (pendingUpdate) {
      setUpdateData(pendingUpdate);
    }
    setIsConfirmOpen(false);
    setPendingUpdate(null);
  };

  const handleCancel = () => {
    setIsConfirmOpen(false);
    setPendingUpdate(null);
  };
  return (
    <Stack spacing={3} bgcolor={white} p={3} borderRadius={8} width="100%">
      <UserDetailRow
        label="Name"
        value={templateData?.name}
        action={() =>
          handleActionClick({
            label: 'Name',
            type: 'text',
            defaultValue: templateData?.name,
            formDataKey: 'name',
            showEditor: false,
          })
        }
      />

      <UserDetailRow
        label="Description"
        value={templateData?.description ?? ''}
        action={() =>
          handleActionClick({
            label: 'Description',
            type: 'text',
            defaultValue: templateData?.description,
            formDataKey: 'description',
            showEditor: true,
          })
        }
        isHtml
      />

      <TemplateCompanyNameModal
        templateData={templateData}
        label={updateData.label}
        type={updateData.type}
        formDataKey={updateData.formDataKey}
        defaultValue={updateData.defaultValue}
        showEditor={updateData.showEditor}
        isOpen={updateData.label ? true : false}
        handleClose={() =>
          setUpdateData({
            label: '',
            type: '',
            formDataKey: '',
            defaultValue: undefined,
            showEditor: false,
          })
        }
      />
      <ConfirmationModal
        open={isConfirmOpen}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </Stack>
  );
};

export default TemplateGenralSettings;
